// A1 - Ünite 1: Present Simple - Olumlu
// Hedef: Geniş zaman olumlu yapı, frequency adverbs

export const A1_UNIT_1 = {
  'A1-U1-L1': {
    id: 'A1-U1-L1',
    title: 'I/You/We/They + fiil',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Present Simple - Çoğul Özneler',
          explanation: 'I, You, We, They ile fiil kök haliyle kullanılır. Bu zamana "Geniş Zaman" denir ve tekrarlayan eylemler, alışkanlıklar ve genel gerçekler için kullanılır.',
          table: {
            headers: ['Özne', 'Fiil', 'Örnek Cümle', 'Türkçesi'],
            rows: [
              ['I', 'work', 'I work at the airport.', 'Havalimanında çalışırım.'],
              ['You', 'fly', 'You fly to London every week.', 'Her hafta Londra\'ya uçarsın.'],
              ['We', 'serve', 'We serve meals on board.', 'Uçakta yemek servis ederiz.'],
              ['They', 'check', 'They check the passengers.', 'Yolcuları kontrol ederler.']
            ]
          }
        },
        {
          type: 'grammar',
          title: '✈️ Havacılık Fiilleri',
          explanation: 'Kabin ekibi olarak sık kullanacağınız fiiller:',
          table: {
            headers: ['Fiil', 'Türkçesi', 'Örnek'],
            rows: [
              ['work', 'çalışmak', 'I work for Turkish Airlines.'],
              ['fly', 'uçmak', 'We fly international routes.'],
              ['serve', 'servis etmek', 'They serve drinks.'],
              ['check', 'kontrol etmek', 'I check the cabin.'],
              ['assist', 'yardım etmek', 'We assist passengers.'],
              ['announce', 'anons yapmak', 'I announce the safety instructions.']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 Kabin memuru mülakatında "I work..." veya "I want to work..." kalıplarını sık kullanacaksınız!'
        },
        {
          type: 'vocabulary',
          title: '✈️ Havacılık Kelimeleri',
          words: [
            { en: 'airport', tr: 'havalimanı', pronunciation: '/ˈeəpɔːt/' },
            { en: 'airline', tr: 'havayolu şirketi', pronunciation: '/ˈeəlaɪn/' },
            { en: 'cabin crew', tr: 'kabin ekibi', pronunciation: '/ˈkæbɪn kruː/' },
            { en: 'passenger', tr: 'yolcu', pronunciation: '/ˈpæsɪndʒər/' },
            { en: 'flight', tr: 'uçuş', pronunciation: '/flaɪt/' }
          ]
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'I _____ at Turkish Airlines.',
          options: ['works', 'work', 'working', 'worked'],
          correct: 'work',
          explanation: 'I ile fiil kök haliyle kullanılır: I work'
        },
        {
          type: 'multipleChoice',
          question: 'We _____ international flights.',
          options: ['flies', 'fly', 'flying', 'flied'],
          correct: 'fly',
          explanation: 'We ile fiil kök haliyle kullanılır: We fly'
        },
        {
          type: 'fillInBlank',
          sentence: 'They _____ (serve) meals during the flight.',
          answer: 'serve',
          hint: 'They ile fiil kök haliyle kullanılır'
        },
        {
          type: 'matching',
          instruction: 'Cümleleri eşleştirin',
          pairs: [
            { left: 'I work', right: 'Çalışırım' },
            { left: 'You fly', right: 'Uçarsın' },
            { left: 'We serve', right: 'Servis ederiz' },
            { left: 'They check', right: 'Kontrol ederler' }
          ]
        },
        {
          type: 'dragDrop',
          instruction: '🔀 Cümleyi doğru sıraya dizin',
          words: ['work', 'Turkish Airlines', 'I', 'at'],
          correctOrder: [2, 0, 3, 1],
          translation: 'Türk Hava Yolları\'nda çalışıyorum.'
        },
        {
          type: 'flashcard',
          title: '🎴 Present Simple Fiiller',
          cards: [
            { front: 'I work', back: 'Çalışırım' },
            { front: 'You fly', back: 'Uçarsın' },
            { front: 'We serve', back: 'Servis ederiz' },
            { front: 'They help', back: 'Yardım ederler' },
            { front: 'I speak', back: 'Konuşurum' }
          ]
        },
        {
          type: 'timeRace',
          title: '⏱️ Fiil Yarışı',
          cards: [
            { front: 'work', back: 'çalışmak' },
            { front: 'fly', back: 'uçmak' },
            { front: 'serve', back: 'servis etmek' },
            { front: 'help', back: 'yardım etmek' },
            { front: 'check', back: 'kontrol etmek' },
            { front: 'land', back: 'inmek' }
          ]
        }
      ]
    }
  },
  'A1-U1-L2': {
    id: 'A1-U1-L2',
    title: 'He/She/It + fiil + s/es',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Present Simple - 3. Tekil Şahıs',
          explanation: 'He, She, It ile fiil sonuna -s veya -es eklenir. Bu kural İngilizcenin en önemli kurallarından biridir!',
          table: {
            headers: ['Özne', 'Fiil', 'Örnek Cümle', 'Türkçesi'],
            rows: [
              ['He', 'works', 'He works as a pilot.', 'Pilot olarak çalışır.'],
              ['She', 'flies', 'She flies to Dubai.', 'Dubai\'a uçar.'],
              ['It', 'takes', 'It takes 3 hours.', '3 saat sürer.'],
              ['The plane', 'lands', 'The plane lands at 5 PM.', 'Uçak saat 5\'te iner.']
            ]
          }
        },
        {
          type: 'grammar',
          title: '📝 -s/-es Kuralları',
          explanation: 'Fiilin son harfine göre ek değişir:',
          table: {
            headers: ['Kural', 'Örnek', 'Açıklama'],
            rows: [
              ['Genel: +s', 'work → works', 'Çoğu fiil'],
              ['-s, -sh, -ch, -x, -o: +es', 'watch → watches', 'Bu seslerle biten fiiller'],
              ['-y (sessiz harf önce): y→ies', 'fly → flies', 'carry → carries'],
              ['-y (sesli harf önce): +s', 'play → plays', 'say → says']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 Mülakatta kendinizi anlatırken: "I work..." ama başkasını anlatırken: "She works..., He works..." kullanın!'
        },
        {
          type: 'vocabulary',
          title: '✈️ Kabin Ekibi Görevleri',
          words: [
            { en: 'greet', tr: 'karşılamak', pronunciation: '/ɡriːt/' },
            { en: 'demonstrate', tr: 'göstermek', pronunciation: '/ˈdemənstreɪt/' },
            { en: 'monitor', tr: 'izlemek', pronunciation: '/ˈmɒnɪtər/' },
            { en: 'respond', tr: 'cevap vermek', pronunciation: '/rɪˈspɒnd/' },
            { en: 'ensure', tr: 'sağlamak', pronunciation: '/ɪnˈʃʊər/' }
          ]
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'She _____ passengers at the door.',
          options: ['greet', 'greets', 'greeting', 'greeted'],
          correct: 'greets',
          explanation: 'She ile fiil sonuna -s eklenir: She greets'
        },
        {
          type: 'multipleChoice',
          question: 'He _____ safety equipment.',
          options: ['check', 'checks', 'checking', 'checked'],
          correct: 'checks',
          explanation: 'He ile fiil sonuna -s eklenir: He checks'
        },
        {
          type: 'fillInBlank',
          sentence: 'The captain _____ (fly) the aircraft.',
          answer: 'flies',
          hint: '-y ile biten fiillerde y→ies olur'
        },
        {
          type: 'matching',
          instruction: 'Fiilleri doğru formlarıyla eşleştirin',
          pairs: [
            { left: 'work', right: 'works' },
            { left: 'fly', right: 'flies' },
            { left: 'watch', right: 'watches' },
            { left: 'play', right: 'plays' }
          ]
        }
      ]
    }
  },
  'A1-U1-L3': {
    id: 'A1-U1-L3',
    title: 'Spelling Rules (-s, -es, -ies)',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Yazım Kuralları Detaylı',
          explanation: '3. tekil şahısta fiile ek yaparken yazım kuralları:',
          table: {
            headers: ['Fiil Sonu', 'Kural', 'Örnekler'],
            rows: [
              ['Çoğu fiil', '+s', 'work→works, read→reads, come→comes'],
              ['-s, -ss, -sh, -ch, -x, -z', '+es', 'pass→passes, wash→washes, watch→watches'],
              ['-o', '+es', 'go→goes, do→does'],
              ['sessiz harf + y', 'y→ies', 'fly→flies, carry→carries, study→studies'],
              ['sesli harf + y', '+s', 'play→plays, say→says, stay→stays'],
              ['have', 'has', 'have→has (düzensiz)']
            ]
          }
        },
        {
          type: 'grammar',
          title: '✈️ Havacılık Fiilleri - 3. Tekil Şahıs',
          table: {
            headers: ['Fiil', 'He/She/It Formu', 'Örnek Cümle'],
            rows: [
              ['check', 'checks', 'The purser checks the cabin.'],
              ['pass', 'passes', 'She passes through security.'],
              ['watch', 'watches', 'He watches the passengers.'],
              ['go', 'goes', 'The flight goes to Paris.'],
              ['carry', 'carries', 'She carries the tray.'],
              ['have', 'has', 'The aircraft has 180 seats.']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 "have" fiili düzensizdir: I have, You have, BUT He/She/It HAS!'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'She _____ the safety video. (watch)',
          options: ['watch', 'watchs', 'watches', 'watching'],
          correct: 'watches',
          explanation: '-ch ile biten fiillere -es eklenir: watch → watches'
        },
        {
          type: 'multipleChoice',
          question: 'The plane _____ 200 passengers. (carry)',
          options: ['carry', 'carrys', 'carries', 'carris'],
          correct: 'carries',
          explanation: 'sessiz harf + y ile biten fiillerde y→ies: carry → carries'
        },
        {
          type: 'fillInBlank',
          sentence: 'She _____ (go) to the airport every day.',
          answer: 'goes',
          hint: '-o ile biten fiillere -es eklenir'
        },
        {
          type: 'fillInBlank',
          sentence: 'The aircraft _____ (have) two engines.',
          answer: 'has',
          hint: 'have → has (düzensiz fiil)'
        }
      ]
    }
  },
  'A1-U1-L4': {
    id: 'A1-U1-L4',
    title: 'Frequency Adverbs (always, never...)',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Sıklık Zarfları',
          explanation: 'Sıklık zarfları bir eylemin ne sıklıkla yapıldığını belirtir. Cümlede fiilden ÖNCE gelir.',
          table: {
            headers: ['Zarf', 'Sıklık', 'Türkçesi'],
            rows: [
              ['always', '100%', 'her zaman'],
              ['usually', '80%', 'genellikle'],
              ['often', '60%', 'sık sık'],
              ['sometimes', '40%', 'bazen'],
              ['rarely/seldom', '20%', 'nadiren'],
              ['never', '0%', 'asla, hiçbir zaman']
            ]
          }
        },
        {
          type: 'grammar',
          title: '📝 Cümledeki Yeri',
          explanation: 'Sıklık zarfı özne ile fiil arasında gelir:',
          table: {
            headers: ['Yapı', 'Örnek', 'Türkçesi'],
            rows: [
              ['I + always + work', 'I always work hard.', 'Her zaman çok çalışırım.'],
              ['She + usually + flies', 'She usually flies to Europe.', 'Genellikle Avrupa\'ya uçar.'],
              ['We + never + delay', 'We never delay the flight.', 'Uçuşu asla geciktirmeyiz.']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 BE fiili ile sıklık zarfı fiilden SONRA gelir: I am always on time. (Her zaman zamanında olurum.)'
        },
        {
          type: 'vocabulary',
          title: '✈️ Kabin Ekibi Rutini',
          words: [
            { en: 'briefing', tr: 'brifing', pronunciation: '/ˈbriːfɪŋ/' },
            { en: 'on time', tr: 'zamanında', pronunciation: '/ɒn taɪm/' },
            { en: 'routine', tr: 'rutin', pronunciation: '/ruːˈtiːn/' },
            { en: 'duty', tr: 'görev', pronunciation: '/ˈdjuːti/' },
            { en: 'schedule', tr: 'program', pronunciation: '/ˈʃedjuːl/' }
          ]
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'I _____ arrive early for briefing.',
          options: ['always', 'arrive always', 'always arrive', 'do always arrive'],
          correct: 'always arrive',
          explanation: 'Sıklık zarfı fiilden önce gelir: I always arrive'
        },
        {
          type: 'multipleChoice',
          question: 'She is _____ polite to passengers.',
          options: ['always', 'usually always', 'be always', 'always be'],
          correct: 'always',
          explanation: 'BE fiiliyle sıklık zarfı BE\'den sonra gelir: She is always polite'
        },
        {
          type: 'fillInBlank',
          sentence: 'We _____ (never/be) late for flights.',
          answer: 'are never',
          hint: 'BE fiili + sıklık zarfı'
        },
        {
          type: 'matching',
          instruction: 'Sıklık zarflarını eşleştirin',
          pairs: [
            { left: 'always', right: 'her zaman' },
            { left: 'usually', right: 'genellikle' },
            { left: 'sometimes', right: 'bazen' },
            { left: 'never', right: 'asla' }
          ]
        }
      ]
    }
  },
  'A1-U1-L5': {
    id: 'A1-U1-L5',
    title: 'Uygulama: Kabin Memuru Rutini',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '✈️ Bir Kabin Memurunun Günü',
          explanation: 'Aşağıda tipik bir kabin memurunun günlük rutini var. Present Simple ve sıklık zarflarının kullanımına dikkat edin:',
          table: {
            headers: ['Saat', 'Aktivite', 'İngilizce'],
            rows: [
              ['05:00', 'Uyanır', 'She wakes up early.'],
              ['06:00', 'Havalimanına gider', 'She goes to the airport.'],
              ['07:00', 'Brifinge katılır', 'She attends the briefing.'],
              ['08:00', 'Kabini kontrol eder', 'She checks the cabin.'],
              ['09:00', 'Yolcuları karşılar', 'She greets the passengers.'],
              ['10:00', 'Güvenlik gösterimi yapar', 'She demonstrates safety procedures.']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 Mülakatta "Tell me about your daily routine" sorusu sıkça sorulur. Bu kalıpları öğrenin!'
        },
        {
          type: 'vocabulary',
          title: '✈️ Mülakat Kelimeleri',
          words: [
            { en: 'wake up', tr: 'uyanmak', pronunciation: '/weɪk ʌp/' },
            { en: 'attend', tr: 'katılmak', pronunciation: '/əˈtend/' },
            { en: 'prepare', tr: 'hazırlamak', pronunciation: '/prɪˈpeər/' },
            { en: 'coordinate', tr: 'koordine etmek', pronunciation: '/kəʊˈɔːdɪneɪt/' },
            { en: 'communicate', tr: 'iletişim kurmak', pronunciation: '/kəˈmjuːnɪkeɪt/' }
          ]
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'A cabin crew member _____ early every day.',
          options: ['wake up', 'wakes up', 'waking up', 'waked up'],
          correct: 'wakes up',
          explanation: '3. tekil şahıs (A cabin crew member) için fiil + s/es'
        },
        {
          type: 'fillInBlank',
          sentence: 'I always _____ (arrive) at the airport on time.',
          answer: 'arrive',
          hint: 'I ile fiil kök haliyle kullanılır'
        },
        {
          type: 'fillInBlank',
          sentence: 'She usually _____ (check) the emergency equipment.',
          answer: 'checks',
          hint: 'She ile fiil + s'
        },
        {
          type: 'speaking',
          instruction: 'Kendi günlük rutininizi anlatın:',
          phrases: [
            'I wake up at...',
            'I usually...',
            'I always...',
            'I sometimes...'
          ]
        }
      ]
    }
  },
  'A1-U1-EXAM': {
    id: 'A1-U1-EXAM',
    title: 'Ünite 1 Sınavı',
    type: 'exam',
    exercises: [
      {
        type: 'multipleChoice',
        question: 'I _____ at Turkish Airlines.',
        options: ['works', 'work', 'working', 'worked'],
        correct: 'work',
        explanation: 'I ile fiil kök haliyle kullanılır.'
      },
      {
        type: 'multipleChoice',
        question: 'She _____ passengers with a smile.',
        options: ['greet', 'greets', 'greeting', 'greeted'],
        correct: 'greets',
        explanation: 'She ile fiil sonuna -s eklenir.'
      },
      {
        type: 'multipleChoice',
        question: 'The plane _____ 180 passengers.',
        options: ['carry', 'carrys', 'carries', 'carris'],
        correct: 'carries',
        explanation: 'sessiz harf + y ile biten fiillerde y→ies'
      },
      {
        type: 'multipleChoice',
        question: 'We _____ fly international routes.',
        options: ['usual', 'usually', 'usualy', 'usualyy'],
        correct: 'usually',
        explanation: 'usually = genellikle (sıklık zarfı)'
      },
      {
        type: 'fillInBlank',
        sentence: 'He always _____ (arrive) on time.',
        answer: 'arrives',
        hint: 'He ile fiil + s'
      },
      {
        type: 'fillInBlank',
        sentence: 'She _____ (go) to briefing every morning.',
        answer: 'goes',
        hint: '-o ile biten fiillere -es eklenir'
      },
      {
        type: 'matchPairs',
        instruction: 'Fiilleri 3. tekil şahıs formlarıyla eşleştirin',
        pairs: [
          { left: 'work', right: 'works' },
          { left: 'fly', right: 'flies' },
          { left: 'watch', right: 'watches' },
          { left: 'have', right: 'has' }
        ]
      }
    ]
  }
};

export default A1_UNIT_1;
